import Image from 'next/image'
import { Stack } from 'components/Stack'
import { Text } from 'components/Text'
import { useTranslation } from 'hooks/useTranslation'
import { DifferenceItem } from './components/DifferenceItem'
import {
  DifferenceItemsList,
  DifferenceRoot,
  Flex,
  ImageContainer,
  IsologoContainer,
  TitleContent,
} from './Difference.styles'

import wfrDifference from '../../../../../../../public/assets/raw-food-subscription/wfr-difference-dog.webp'
import isologo from '../../../../../../../public/assets/isologo.svg'

import meal from '../../../../../../../public/assets/raw-food-subscription/meal.svg'
import chicken from '../../../../../../../public/assets/raw-food-subscription/chicken.svg'
import safety from '../../../../../../../public/assets/raw-food-subscription/safety.svg'

export const Difference = () => {
  const { t } = useTranslation()

  return (
    <DifferenceRoot id="raw-food-subscription-3">
      <Flex>
        <TitleContent>
          <Stack direction="column" gap="4">
            <Stack direction="column" gap="3">
              <Text as="h2" size="h1" weight="bold">
                {t('raw-food-subscription:difference.title')}
              </Text>

              <Text size="headline" weight="bold">
                {t('raw-food-subscription:difference.subtitle')}
              </Text>
            </Stack>

            <Text size="headline">{t('raw-food-subscription:difference.description')}</Text>
          </Stack>
        </TitleContent>

        <ImageContainer>
          <IsologoContainer>
            <Image src={isologo} alt="" width={120} height={120} />
          </IsologoContainer>

          <Image src={wfrDifference} alt={t('raw-food-subscription:difference.alt')} />
        </ImageContainer>
      </Flex>

      <DifferenceItemsList>
        <DifferenceItem
          title={t('raw-food-subscription:difference.meal.title')}
          description={t('raw-food-subscription:difference.meal.description')}
          image={meal}
        />

        <DifferenceItem
          title={t('raw-food-subscription:difference.chicken.title')}
          description={t('raw-food-subscription:difference.chicken.description')}
          image={chicken}
        />

        <DifferenceItem
          title={t('raw-food-subscription:difference.safety.title')}
          description={t('raw-food-subscription:difference.safety.description')}
          image={safety}
        />
      </DifferenceItemsList>
    </DifferenceRoot>
  )
}
